module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--space-cocostoriesc76e8ba82b9bf5648f6ceca9b8cd3b54.svg";